/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'
import objectFitImages from 'object-fit-images'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import SendForm from './modules/SendForm'
import NavDropdown from './modules/NavDropdown'
import MobileHeader from './modules/MobileHeader'
import LazyLoadBackground from './modules/LazyLoadBackground'
import Hero from './modules/Hero'
import BackToTop from './modules/BackToTop'
import PhoneLink from './modules/PhoneLink'
import LanguageSwitcher from './modules/LanguageSwitcher'
import Maps from './modules/Maps'
import ProjectsSlider from './modules/ProjectsSlider'
import DependsOn from './modules/DependsOn'
  ;(function IIFE() {
  ObserveFontFace()
  FormValidation()
  SendForm()
  objectFitImages()
  NavDropdown()
  MobileHeader()
  LazyLoadBackground()
  Hero()
  BackToTop()
  PhoneLink()
  Maps()
  ProjectsSlider()
  DependsOn()
  LanguageSwitcher()
})()



// WEBPACK FOOTER //
// ./src/js/main.js